import { render, staticRenderFns } from "./base-slider.vue?vue&type=template&id=00b8d3d5&scoped=true"
import script from "./base-slider.vue?vue&type=script&lang=js"
export * from "./base-slider.vue?vue&type=script&lang=js"
import style0 from "./base-slider.vue?vue&type=style&index=0&id=00b8d3d5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_675154ded190a7e2d3ad9efb69cc05e3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b8d3d5",
  null
  
)

export default component.exports